import authClient from './authClient';

export const screenHostLogin = (email, password) => {
    return authClient.post(process.env.REACT_APP_API_URL + '/screenHostLogin', { email, password });
};
